<template>
    <div>
        <v-card-title style="" >
            <v-list-item style="margin:-15px">

                <v-list-item-content>
                    <v-list-item-title class="title">{{ titulo }}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-1"> <small>{{ subTitulo }}</small> </v-list-item-subtitle>
                </v-list-item-content>

                <v-spacer></v-spacer>
                <v-icon x-large>{{ icono }}</v-icon>
            </v-list-item>
        </v-card-title>
        <v-divider></v-divider>
    </div>
</template>

<script>
    export default {
        name: "EncabezadoCard",
        props: {
            titulo: String,
            subTitulo: String,
            icono: String,

        }
    }
</script>

<style scoped>

</style>